import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Department} from '../../../shared/interface/department';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';

@Component({
  selector: 'app-department-details-view',
  templateUrl: './department-details-view.component.html',
  styleUrls: ['./department-details-view.component.scss']
})
export class DepartmentDetailsViewComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  @Input() department: Observable<Department>;
  @Output() modifyClicked = new EventEmitter<any>();
  departmentObject?: Department;
  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private auth: AuthService
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.department
      .pipe(takeUntil(this.destroyed$))
      .subscribe((department: Department) => this.departmentObject = department);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }
}
